export enum SiteResourcesEnum {
  Sites = "sites",
  SiteRecord = "siteRecord",
  Statuses = "statuses",
  StatusesV2 = "statusesV2",
  StatusesV2Latest = "statusesV2Latest",
  Groups = "groups",
  Telemetry1S = "telemetry1S",
  NLevels = "nLevels",
  SiteConfigurations = "configurations",
  PerformanceChronicles = "performanceChronicles",
  PerformanceChronicleResults = "performanceChronicleResults",
  PerformanceChronicleGeneration = "performanceChroniclesGeneration",
  PerformanceChronicleTestSending = "PerformanceChronicleTestSending",
  Certifications = "certifications",
  CertificationRtePhase2 = "certificationRtePhase2",
  Chronicles = "chronicles",
  SiteExport = "export",
  SiteUpload = "upload",
  Associations = "associations",
}

export enum MaintenanceResourcesEnum {
  Maintenance = "maintenance",
}

export enum UserResourcesEnum {
  Users = "users",
}

export enum RegelleistungResourcesEnum {
  RegelleistungBids = "regelleistungBids",
  RegelleistungBidsVisualization = "regelleistungBidsVisualization",
}

export enum PlanningResourcesEnum {
  Plannings = "plannings",
  PlanningMasks = "planningMasks",
}

export enum RteCommunicationV2ResourcesEnum {
  RteCommunicationConfig = "rteCommunicationConfig",
  RteCommunicationFakePa = "rteCommunicationFakePa",
  RteCommunicationTestConfig = "rteCommunicationTestConfig",
  RteCommunicationMarketConfig = "rteCommunicationMarketConfig",
}

export enum FinlandCommunicationResourcesEnum {
  Protocols = "protocols",
  ModbusSiteMetrics = "modbus-site-metrics",
  Configs = "configs",
  ConfigProtocolParameters = "config-protocol-parameters",
  Packets = "packets",
  Modbus = "modbus",
}

export enum TestsRteResourcesEnum {
  TestsRtePlannings = "testsRtePlannings",
  TestsAfrrRte = "testsAfrrRte",
  TestsFcrRte = "testsFcrRte",
}

export enum OptimizerResourcesEnum {
  OptiCertifications = "optiCertifications",
  OptiCertificationsTests = "optiCertificationsTests",
  OptiGroupsCertifications = "optiGroupsCertifications",
  OptiTasks = "optiTasks",
  OptiGains = "optiGains",
}

export enum AfrrEngagementResourcesEnum {
  Engagement = "engagement",
  Documents = "documents",
  GateDocument = "gateDocument",
  BidTimeSeries = "bidTimeSeries",
  Point = "point",
  PointWithOperator = "pointWithOperator",
}

export enum TopNiveauResourcesEnum {
  TopNiveauBids = "topNiveauBids",
  TopNiveauGates = "topNiveauGates",
  TopNiveauDocuments = "topNiveauDocuments",
}

export enum EcpResourcesEnum {
  EcpBids = "ecpBids",
  EcpGates = "ecpGates",
  EcpReservePlanGates = "ecpReservePlanGates",
  EcpReservePlanPoints = "ecpReservePlanPoints",
  EcpFcrDVisualization = "ecpFcrDVisualization",
  EcpFcrNVisualization = "ecpFcrNVisualization",
}

export enum TestsFingridEnum {
  TestFingridFcrN = "TestFingridFcrN",
  TestFingridFcrD = "TestFingridFcrD",
  TestFingridAfrr = "TestFingridAfrr",
  TestFingridCsvGeneration = "TestFingridCsvGeneration",
}

export enum MecapaResourcesEnum {
  EmaxJGates = "emaxJGates",
  EmaxHGates = "emaxHGates",
  RtePowerGates = "rtePowerGates",
}

const {
  REACT_APP_AUTH_API_URL,
  REACT_APP_SITE_API_URL,
  REACT_APP_MAINTENANCE_API_URL,
  REACT_APP_REGELLEISTUNG_API_URL,
  REACT_APP_PLANNINGS_API_URL,
  REACT_APP_OPTIMIZER_API_URL,
  REACT_APP_IEC_API_URL,
  REACT_APP_AFRR_ENGAGEMENT_API_URL,
  REACT_APP_TOP_NIVEAU_API_URL,
  REACT_APP_ECP_API_URL,
  REACT_APP_MECAPA_API_URL,
  REACT_APP_FINLAND_COMMUNICATION_API_URL,
} = process.env;

type ResourceMappingType<T> = Record<T & "root", string>;

// Sites Resource Mapping
export const SiteResourceMapping: ResourceMappingType<SiteResourcesEnum> = {
  root: REACT_APP_SITE_API_URL as string,
  [SiteResourcesEnum.Sites]: "sites",
  [SiteResourcesEnum.SiteRecord]: "sites/site_record/",
  [SiteResourcesEnum.Statuses]: "sites/sites-statuses/",
  [SiteResourcesEnum.StatusesV2]: "sites/status_v2/",
  [SiteResourcesEnum.StatusesV2Latest]: "sites/status_v2/latest/",
  [SiteResourcesEnum.Groups]: "sites/groups/",
  [SiteResourcesEnum.Telemetry1S]: "sites/sites-telemetry/1s/",
  [SiteResourcesEnum.NLevels]: "sites/n_levels/",
  [SiteResourcesEnum.PerformanceChronicles]: "sites/performance_chronicles/",
  [SiteResourcesEnum.PerformanceChronicleResults]: "sites/performance_chronicle_results/",
  [SiteResourcesEnum.SiteConfigurations]: "sites/configurations/",
  [SiteResourcesEnum.PerformanceChronicleGeneration]: "",
  [SiteResourcesEnum.PerformanceChronicleTestSending]: "",
  [SiteResourcesEnum.Certifications]: "sites/certifications",
  [SiteResourcesEnum.CertificationRtePhase2]: "sites/certifications/rte/phase-2",
  [SiteResourcesEnum.Chronicles]: "sites/chronicles",
  [SiteResourcesEnum.SiteExport]: "sites/export",
  [SiteResourcesEnum.SiteUpload]: "sites/upload",
  [SiteResourcesEnum.Associations]: "sites/groups_sites/",
};

// Maintenance Resource Mapping
export const MaintenanceResourceMapping: ResourceMappingType<MaintenanceResourcesEnum> = {
  root: REACT_APP_MAINTENANCE_API_URL as string,
  [MaintenanceResourcesEnum.Maintenance]: "maintenance/maintenances",
};

// Users Resource Mapping
export const UserResourceMapping: ResourceMappingType<UserResourcesEnum> = {
  root: REACT_APP_AUTH_API_URL as string,
  [UserResourcesEnum.Users]: "users",
};

// Regelleistung Resource Mapping
export const RegelleistungResourceMapping: ResourceMappingType<RegelleistungResourcesEnum> = {
  root: REACT_APP_REGELLEISTUNG_API_URL as string,
  [RegelleistungResourcesEnum.RegelleistungBids]: "regelleistung/bids/",
  [RegelleistungResourcesEnum.RegelleistungBidsVisualization]: "regelleistung/bids/visualization/",
};

// Plannings Resource Mapping
export const PlanningResourceMapping: ResourceMappingType<PlanningResourcesEnum> = {
  root: REACT_APP_PLANNINGS_API_URL as string,
  [PlanningResourcesEnum.Plannings]: "plannings/",
  [PlanningResourcesEnum.PlanningMasks]: "plannings/planning-masks/",
};

// RTE communication V2 Resource Mapping
export const RteCommunicationV2ResourceMapping: ResourceMappingType<RteCommunicationV2ResourcesEnum> = {
  root: REACT_APP_IEC_API_URL as string,
  [RteCommunicationV2ResourcesEnum.RteCommunicationConfig]: "config/",
  [RteCommunicationV2ResourcesEnum.RteCommunicationFakePa]: "fake-pa/",
  [RteCommunicationV2ResourcesEnum.RteCommunicationTestConfig]: "test-config/",
  [RteCommunicationV2ResourcesEnum.RteCommunicationMarketConfig]: "market-config/",
};

// Finland Communication Resource Mapping
export const FinlandCommunicationResourceMapping: ResourceMappingType<FinlandCommunicationResourcesEnum> = {
  root: REACT_APP_FINLAND_COMMUNICATION_API_URL as string,
  [FinlandCommunicationResourcesEnum.Protocols]: "protocols/",
  [FinlandCommunicationResourcesEnum.ModbusSiteMetrics]: "modbus-site-metrics/",
  [FinlandCommunicationResourcesEnum.Configs]: "configs/",
  [FinlandCommunicationResourcesEnum.ConfigProtocolParameters]: "config-protocol-parameters/",
  [FinlandCommunicationResourcesEnum.Packets]: "packets/",
  [FinlandCommunicationResourcesEnum.Modbus]: "modbus/",
};

// Tests RTE Resource Mapping
export const TestsRteResourceMapping: ResourceMappingType<TestsRteResourcesEnum> = {
  root: REACT_APP_IEC_API_URL as string,
  [TestsRteResourcesEnum.TestsRtePlannings]: "testsRte/plannings",
  [TestsRteResourcesEnum.TestsAfrrRte]: "",
  [TestsRteResourcesEnum.TestsFcrRte]: "",
};

// Optimizer Resource Mapping
export const OptimizerResourceMapping: ResourceMappingType<OptimizerResourcesEnum> = {
  root: REACT_APP_OPTIMIZER_API_URL as string,
  [OptimizerResourcesEnum.OptiCertifications]: "certifications",
  [OptimizerResourcesEnum.OptiCertificationsTests]: "certifications_tests",
  [OptimizerResourcesEnum.OptiGroupsCertifications]: "groupscertifications",
  [OptimizerResourcesEnum.OptiTasks]: "opti_tasks",
  [OptimizerResourcesEnum.OptiGains]: "gains",
};

// AFRR Engagement Resource Mapping
export const AfrrEngagementResourceMapping: ResourceMappingType<AfrrEngagementResourcesEnum> = {
  root: REACT_APP_AFRR_ENGAGEMENT_API_URL as string,
  [AfrrEngagementResourcesEnum.Engagement]: "engagement/",
  [AfrrEngagementResourcesEnum.Documents]: "documents",
  [AfrrEngagementResourcesEnum.GateDocument]: "gate_document",
  [AfrrEngagementResourcesEnum.BidTimeSeries]: "bidtimeseries",
  [AfrrEngagementResourcesEnum.Point]: "point",
  [AfrrEngagementResourcesEnum.PointWithOperator]: "point/with_operator/",
};

// Top Niveau Resource Mapping
export const TopNiveauResourceMapping: ResourceMappingType<TopNiveauResourcesEnum> = {
  root: REACT_APP_TOP_NIVEAU_API_URL as string,
  [TopNiveauResourcesEnum.TopNiveauBids]: "bids",
  [TopNiveauResourcesEnum.TopNiveauGates]: "gates",
  [TopNiveauResourcesEnum.TopNiveauDocuments]: "documents",
};

// ECP Resource Mapping
export const EcpResourceMapping: ResourceMappingType<EcpResourcesEnum> = {
  root: REACT_APP_ECP_API_URL as string,
  [EcpResourcesEnum.EcpBids]: "bids",
  [EcpResourcesEnum.EcpGates]: "gate",
  [EcpResourcesEnum.EcpReservePlanGates]: "reserve_plan_gate",
  [EcpResourcesEnum.EcpReservePlanPoints]: "reserve_plan_points",
  [EcpResourcesEnum.EcpFcrDVisualization]: "",
  [EcpResourcesEnum.EcpFcrNVisualization]: "",
};

// Mecapa Resource Mapping
export const MecapaResourceMapping: ResourceMappingType<MecapaResourcesEnum> = {
  root: REACT_APP_MECAPA_API_URL as string,
  [MecapaResourcesEnum.EmaxJGates]: "emax_j/",
  [MecapaResourcesEnum.EmaxHGates]: "emax_h/",
  [MecapaResourcesEnum.RtePowerGates]: "rte_power/",
};

export const dataProviderMappings = [
  SiteResourceMapping,
  MaintenanceResourceMapping,
  UserResourceMapping,
  RegelleistungResourceMapping,
  PlanningResourceMapping,
  RteCommunicationV2ResourceMapping,
  TestsRteResourceMapping,
  OptimizerResourceMapping,
  AfrrEngagementResourceMapping,
  TopNiveauResourceMapping,
  EcpResourceMapping,
  FinlandCommunicationResourceMapping,
  MecapaResourceMapping,
];

const combineResources = (dataProviderMappings: ResourceMappingType<any>[]) => {
  // eslint-disable-next-line
  return dataProviderMappings.reduce((acc, { root, ...endpoints }) => {
    return { ...acc, ...endpoints };
  }, {});
};

export const ResourceMapping = combineResources(dataProviderMappings);

export const getRawUrlBase = (enumKey: string): string => {
  const mapping = dataProviderMappings.find((m) => enumKey in m);
  if (!mapping) {
    throw new Error(`Unknown resource "${String(enumKey)}" – not found in any mapping.`);
  }

  const root = (mapping as ResourceMappingType<unknown>)["root"];
  if (!root) {
    throw new Error(`Base URL (root) is not set for resource "${String(enumKey)}". Check your env vars.`);
  }

  const endpoint = (mapping as ResourceMappingType<any>)[enumKey as string];
  return `${root}/${endpoint}`;
};
